import { c as _c } from "react/compiler-runtime";
import React from "react";
import style from "./DKAgreementMembershipLine.module.scss";
export const DKAgreementMembershipLine: React.FC<{
  prefix: string;
  label: string;
}> = t0 => {
  const $ = _c(5);
  const {
    prefix,
    label
  } = t0;
  let t1;
  if ($[0] !== prefix) {
    t1 = <span className={style.prefix}>{prefix}</span>;
    $[0] = prefix;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== label || $[3] !== t1) {
    t2 = <p className={style.membershipLine} data-cy="dk-agreement-membership">{t1}{label}</p>;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};